"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalLayoutRenderer = void 0;
exports.VerticalLayout = VerticalLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const LayoutRenderer_1 = require("./LayoutRenderer");
const antd_1 = require("antd");
const react_1 = require("@jsonforms/react");
function VerticalLayout({ uischema, schema, path, enabled, visible, renderers, cells, }) {
    const verticalLayout = uischema;
    const groupLayout = uischema;
    const childProps = {
        elements: verticalLayout.elements,
        schema,
        path,
        enabled,
        visible,
    };
    const form = antd_1.Form.useFormInstance();
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form, { ...getFormLayoutOptions(form), form: form, children: [!groupLayout.label && ((0, jsx_runtime_1.jsx)("div", { children: groupLayout.label }) // this was SubtitleSemiBold
            ), (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...childProps, renderers: renderers, cells: cells })] }));
}
function getFormLayoutOptions(form) {
    return {
        scrollToFirstError: true,
        component: form ? "div" : "form",
    };
}
exports.VerticalLayoutRenderer = (0, react_1.withJsonFormsLayoutProps)(VerticalLayout);
